module.exports = __webpack_public_path__ + "img/30.5504f381.webp";